import { ApiService } from '../api.service';
import { Injectable } from '@angular/core';
import { Commande } from '../../models/Commande';

@Injectable({
  providedIn: 'root'
})
export class LocaliteService {

  constructor(private api: ApiService) { }

  
  findCodedz() {
    return this.api.get('/common/localites/search-codedz');
  }

  findCodeSousZone(numero: any) {
    return this.api.get('/common/localites/search-souszone?n=' + numero);
  }

  findCodeSecteur(numero: any) {
    return this.api.get('/common/localites/search-secteur?n=' + numero);
  }

  findCodeLocalitedd(numero: any) {
    return this.api.get('/common/localites/search-localitedd?n=' + numero);
  }

  
}
